{
  "EmailRule_Failed": "L'email doit être valide",
  "NAME": "GenericRuleLanguage"
}